/**
 * FutureTec — Umbrella Brand Identity — single source of truth.
 *
 *   variant     "college" | "institute". Locked to "college" now that
 *               college.futuretec.global has been registered and pointed
 *               at the production droplet. Flip to "institute" only if
 *               the umbrella brand is re-registered on the .institute
 *               ccTLD later.
 *
 *   domain      the public hostname the product is served on. Consumed
 *               by copy, canonical links, sitemap, share cards, etc.
 */
export const BRAND = {
  variant: "college",   // "college" | "institute"
  formalName: {
    college:   "The FutureTec College of AI and Advanced Robotics",
    institute: "The FutureTec Institute of AI and Advanced Robotics",
  },
  shortName: {
    college:   "FutureTec College",
    institute: "FutureTec Institute",
  },
  tradingClause: "A trading name of Qualification Evaluation UK Ltd., registered in the United Kingdom.",
  domain: "college.futuretec.global",
};

export const getBrand = () => ({
  formal:  BRAND.formalName[BRAND.variant],
  short:   BRAND.shortName[BRAND.variant],
  trading: BRAND.tradingClause,
  domain:  BRAND.domain,
});
